(function() {

var doc = d.documentElement;
var prevScroll;
var prevDirection;

ui.loadAdd(onLoad);

function onLoad(event) {
  ui.categoryMenuClick = categoryMenuClick;
  ui.categoryToggle = categoryToggle;
  ui.mobileMenuClick = mobileMenuClick;
  ui.mobileMenuClose = mobileMenuClose;
  ui.mobileAccordion = mobileAccordion;
  ui.headerHE = d.getElementById('header');
  prevScroll = w.scrollY || doc.scrollTop;
  prevDirection = 0;
  w.addEventListener('scroll', checkScroll);
  initCatalogHover();
}

function initCatalogHover() {
  var items = d.querySelectorAll('.catalog-cat-item');
  for(var i = 0; i < items.length; i++) {
    items[i].addEventListener('mouseenter', catalogCatHover);
  }
}

function catalogCatHover(event) {
  var catId = this.getAttribute('data-cat-id');
  var panels = d.querySelectorAll('.catalog-sub-panel');
  for(var i = 0; i < panels.length; i++) {
    if(panels[i].getAttribute('data-cat-id') === catId)
      panels[i].classList.remove('hidden');
    else
      panels[i].classList.add('hidden');
  }
  var items = d.querySelectorAll('.catalog-cat-item');
  for(var i = 0; i < items.length; i++) {
    if(items[i] === this) {
      items[i].classList.add('bg-white', 'text-black');
      items[i].classList.remove('text-gray-700');
    } else {
      items[i].classList.remove('bg-white', 'text-black');
      items[i].classList.add('text-gray-700');
    }
  }
}

function categoryMenuClick(event) {
  var menu = d.getElementById('catalog-btn');
  if(!menu)
    return;
  var isHidden = menu.classList.contains('hidden');
  if(isHidden) {
    menu.classList.remove('hidden', 'scale-95', 'opacity-0', 'pointer-events-none');
    menu.classList.add('scale-100', 'opacity-100', 'pointer-events-auto');
    catalogBtnActive(true);
    d.addEventListener('click', catalogOutsideClick, true);
  } else {
    catalogMenuClose(menu);
  }
}

function catalogMenuClose(menu) {
  if(!menu)
    menu = d.getElementById('catalog-btn');
  if(!menu)
    return;
  menu.classList.add('scale-95', 'opacity-0', 'pointer-events-none');
  menu.classList.remove('scale-100', 'opacity-100', 'pointer-events-auto');
  catalogBtnActive(false);
  setTimeout(function() { menu.classList.add('hidden'); }, 300);
  d.removeEventListener('click', catalogOutsideClick, true);
}

function catalogBtnActive(active) {
  var btn = d.getElementById('catalog-toggle');
  if(!btn)
    return;
  var iconMenu = btn.querySelector('.catalog-icon-menu');
  var iconClose = btn.querySelector('.catalog-icon-close');
  if(active) {
    btn.classList.add('bg-dark', 'text-hero-fg');
    btn.classList.remove('bs-btn-catalog');
    if(iconMenu) iconMenu.classList.add('hidden');
    if(iconClose) iconClose.classList.remove('hidden');
  } else {
    btn.classList.remove('bg-dark', 'text-hero-fg');
    btn.classList.add('bs-btn-catalog');
    if(iconMenu) iconMenu.classList.remove('hidden');
    if(iconClose) iconClose.classList.add('hidden');
  }
}

function catalogOutsideClick(event) {
  var menu = d.getElementById('catalog-btn');
  var btn = menu ? menu.previousElementSibling : null;
  if(menu && !menu.contains(event.target) && (!btn || !btn.contains(event.target))) {
    catalogMenuClose(menu);
  }
}

function categoryToggle(event) {
  if((w.innerWidth > 1024) || !event.target.parentElement.classList.contains('header-category-top-link'))
    return;
  var he = event.target;
  while(he) {
    if(he === event.currentTarget)
      break;
    if(he.classList.contains('header-category-top')) {
      var exists = he.classList.toggle('header-category-top-expanded');
      var hes = he.getElementsByTagName('i');
      for(var i = 0; i < hes.length; i++)
        hes[i].className = 'fa ' + (exists ? 'fa-angle-up' : 'fa-angle-down');
      break;
    }
    he = he.parentElement;
  }
}

function mobileMenuClick(event) {
  var menu = d.getElementById('mobile-menu');
  if(!menu)
    return;
  menu.classList.remove('-translate-x-full');
  menu.classList.add('translate-x-0');
}

function mobileAccordion(btn) {
  var panel = btn.parentElement.querySelector('.mob-accordion-panel');
  if(!panel) {
    var parent = btn.closest('.flex.items-center');
    if(parent) panel = parent.nextElementSibling;
  }
  if(!panel)
    return;
  var isHidden = panel.classList.contains('hidden');
  panel.classList.toggle('hidden');
  var chevron = btn.querySelector('.mob-accordion-chevron');
  if(chevron) {
    if(isHidden) {
      chevron.classList.add('rotate-180');
      btn.classList.remove('bg-gray-50');
      btn.classList.add('bg-brand');
    } else {
      chevron.classList.remove('rotate-180');
      btn.classList.add('bg-gray-50');
      btn.classList.remove('bg-brand');
    }
  }
}

function mobileMenuClose() {
  var menu = d.getElementById('mobile-menu');
  if(!menu)
    return;
  menu.classList.add('-translate-x-full');
  menu.classList.remove('translate-x-0');
}

function checkScroll(event) {
  if(!ui.headerHE)
    return;
  var curScroll = w.scrollY || doc.scrollTop;
  var direction = curScroll > prevScroll ? 2 : 1;
  if(direction !== prevDirection) {
    if (direction === 2 && curScroll > 114) {
      ui.headerHE.style.transform = 'translateY(-100%)';
      prevDirection = direction;
    } else if (direction === 1) {
      ui.headerHE.style.transform = '';
      prevDirection = direction;
    }
  }
  prevScroll = curScroll;
}

})();